import axios from 'axios';

export interface UploadFilePayload {
  url: string;
  path: string;
  awsFileName?: string;
}

export const getUploadFileClient =
  (apiClient: any) =>
  async (
    file: File,
    endpoint: string,
    queryParams: Record<string, string>,
    options: { headers?: Record<string, string>; onProgressUpdated?: (progress: number) => void } = {}
  ): Promise<UploadFilePayload> => {
    const { signedRequest, url, path, awsFileName } = await apiClient.get(endpoint, { contentType: file.type, ...queryParams });

    await axios.put(signedRequest, file, {
      onUploadProgress: (progressEvent: any) => {
        if (!progressEvent.total) return;
        const progress = progressEvent.loaded / progressEvent.total;
        options.onProgressUpdated?.(progress);
      },
      headers: {
        ...options.headers,
        'Content-Type': file.type,
      },
    });

    return { url, path, awsFileName };
  };
